import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

import { GapBox } from 'components/Box'
import { TextLink } from 'components/Link'
import Paper from 'components/Paper'
import { TableHeader } from 'components/Table'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'
import { WorkspacePrebidModuleTable } from '../../components/WorkspacePrebidModuleTable'
import { KNOWLEDGE_BASE_URL } from './constants'
import { useColumns } from './hooks/useColumns'

export const AnalyticsAdaptersList = (): React.JSX.Element => {
  const ability = useAbility()
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation(['features/globalSetup', 'common'])
  const columns = useColumns()

  const navigate = useNavigate()

  const AddAnalyticsAdaptersButton = (): React.JSX.Element => (
    <Button
      data-cy='add-analytics-adapters-button'
      onClick={() =>
        navigate(generatePath(ROUTES.GLOBAL_SETUP.PREBID.MODULES.ANALYTICS.ADD, { workspaceId }))
      }
      variant='contained'
    >
      {t('common:actions.addNew')}
    </Button>
  )

  const canCreate: boolean = ability.can('create', 'GlobalSetupFeature-analytics')

  return (
    <Paper>
      <TableHeader
        actions={canCreate ? <AddAnalyticsAdaptersButton /> : undefined}
        description={
          canCreate
            ? t('prebid.modules.analytics.list.description.employee')
            : t('prebid.modules.analytics.list.description.viewer')
        }
        descriptionEndAdornment={
          <TextLink
            link={{
              title: t('common:learnMore'),
              url: KNOWLEDGE_BASE_URL,
            }}
          />
        }
        title={t('prebid.modules.analytics.list.title')}
      />

      <GapBox />

      <WorkspacePrebidModuleTable
        columns={columns}
        moduleType='analytics'
      />
    </Paper>
  )
}
